/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Manual_QcInputs */



/**
* | output |
* | --- |
* | "Manual QC" |
*
* @param {Options_Quicktools_Manual_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_manual_qc = /** @type {((inputs?: Options_Quicktools_Manual_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Manual_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("QC manuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuelle Qualitätskontrolle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo qualità manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ручной контроль качества")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de calidad manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工质检")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動QC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनुअल क्यूसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de qualidade manual")
	return /** @type {LocalizedString} */ ("Manual QC")
});